import { FC, useMemo, useCallback } from 'react'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { setShownSidebarPaneActionCreator } from 'actions/sidebarActions'
import { shownSidebarPaneSelector } from 'selectors/globalSelectors'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/PeergroupLegend/PeergroupLegend.styl'

type PeergroupLegendProps = {
  othersName?: string
  theme?: 'regular' | 'top-spendings'
}

const PeergroupLegend: FC<PeergroupLegendProps> = (props) => {
  const {
    othersName,
    theme = 'regular',
  } = props

  const className = useMemo(() => cn(styles.legend, {
    [styles.topSpendings]: theme === 'top-spendings',
    [styles.regular]: theme === 'regular',
  }), [theme])


  const dispatch = useStoreDispatch()
  const shownSidebar = useStoreSelector(shownSidebarPaneSelector)
  const groupsAreOpen = shownSidebar === 'groups'

  const handleClick = useCallback(() => {
    dispatch(setShownSidebarPaneActionCreator('groups'))
  }, [dispatch])

  return (
    <ul className={ className }>
      <li className={ cn(styles.row, styles.member) }>
        <div className={ styles.circle } />
        <div className={ styles.groupName }>You</div>
      </li>
      <li className={ cn(styles.row, styles.peers) }>
        <div className={ styles.circle } />
        <div className={ styles.groupName }>Your Peers</div>
      </li>
      <li className={ cn(styles.row, styles.others) }>
        <button className={ styles.othersLink } onClick={ handleClick } disabled={ groupsAreOpen }>
          <div className={ styles.circle } />
          <div className={ styles.groupName }>{ othersName }</div>
        </button>
      </li>
    </ul>
  )
}

PeergroupLegend.defaultProps = {
  othersName: 'National Average',
}

export default PeergroupLegend
